import { render, staticRenderFns } from "./order-remark-template.vue?vue&type=template&id=63901348&"
import script from "./order-remark-template.vue?vue&type=script&lang=js&"
export * from "./order-remark-template.vue?vue&type=script&lang=js&"
import style0 from "./order-remark-template.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports